import { NudosGenericModal, NudosModalContent } from '../NudosComponents';
import { ICommentsAndObservations } from '../../types/global';
import { IResponsibleUserData } from '../../types/responsibleUser.types';
import { CommentsContent } from './components';
import './BordCommentsAndObservations.scss';

const BordCommentsAndObservations = ({
  closeModalCallback,
  comments,
  handleSubmitComments,
  closesOnClickOutside,
  clickOutsideCallback,
  loading,
  responsibleUsers,
  organizationId
}: {
  closeModalCallback: () => void;
  comments?: ICommentsAndObservations[];
  handleSubmitComments?: (comment: ICommentsAndObservations) => Promise<void>;
  closesOnClickOutside?: boolean;
  clickOutsideCallback?: () => void;
  loading: boolean;
  responsibleUsers?: IResponsibleUserData[];
  organizationId?: number;
}) => {
  return (
    <div className="bordCommentsAndObservations">
      <NudosGenericModal
        closeModalCallback={closeModalCallback}
        closesOnClickOutside={closesOnClickOutside}
        clickOutsideCallback={clickOutsideCallback}
        customClassName="bordCommentsAndObservationsModal"
        modalContent={
          <NudosModalContent
            customWidth="580px"
            customHeight="fit-content"
            hideNudosIcon={true}
            modalContentTitle="Comentarios y Observaciones"
            toCloseModal={closeModalCallback}
            CustomModalComponent={
              <CommentsContent
                comments={comments}
                handleSubmitComments={handleSubmitComments}
                loading={loading}
                responsibleUsers={responsibleUsers}
                organizationId={organizationId}
              />
            }
          />
        }
      />
    </div>
  );
};

export default BordCommentsAndObservations;
